import { createSlice } from "@reduxjs/toolkit";
import { ManageSubUsersStatus } from '../../config'; 

const initialState = {
    partnerStatus: 'success-ai-user',
    permissions: {
        manageSubUsers: ManageSubUsersStatus.NONE,
        manageBranding: false,
        managePlans: false,
        manageTeamMembers: false
    }
};

const whiteLabelTeamMemberStatus = createSlice({
    name: 'whiteLabelTeamMemberStatus',
    initialState,
    reducers: {
        setWhiteLabelTeamMemberStatus: (state, action) => {
            state.partnerStatus = action.payload.partnerStatus;
            state.permissions = action.payload.permissions;
        }
    }
}); 

export default whiteLabelTeamMemberStatus.reducer;
export const { setWhiteLabelTeamMemberStatus } = whiteLabelTeamMemberStatus.actions;